import headerComponent from '@/components/cust_components/cust_header_component.vue';
import FooterComponent from '@/components/cust_components/cust_footer_component.vue';
import custPopover from '@/components/cust_components/cust_popover_component.vue';
import axios from 'axios';
import LoaderPopover from '@/components/loaderpopover_component.vue';



export default {
    name: 'PaymentComp',
    components: {
        headerComponent,
        FooterComponent,
        custPopover,
        LoaderPopover,


    },
    data() {
        return {
            //square//
            show_square: true, ////
            appId: '',
            locationId: '',
            value: 'square',
            square_card: true,
            square: true,
            square_checked: true,
            square_payment_object: null,
            payment_card: false,
            square_pay_amount: 0,
            square_payment_response: '',
            square_response_object: '',
            sqCard: '',
            cardClassSelectors: {

                input: {
                    backgroundColor: '#ffffff',
                    fontSize: '16px',
                    fontWeight: 'normal',
                },

                'input.is-focus': {
                    backgroundColor: '#ffffff',
                    fontSize: '16px',
                    fontWeight: 'normal'
                },

                '.input-container': {
                    borderColor: 'lightgrey',
                    borderWidth: '1px',
                },

                '.input-container.is-focus': {
                    borderColor: '#cc0023',
                    borderWidth: '0 0 2px 0',
                },

                '.input-container.is-error': {
                    borderColor: '#006aff',
                    borderWidth: '0 0 2px 0',
                },

                '.message-icon': {
                    color: 'green',
                },

                // You can use media queries with valid selectors:

                '@media screen and (max-width: 600px)': {

                    input: {

                        'fontSize': '16px',

                    }

                }

            },
            //square
            str_card_load: true,
            show_stripe: true, /////
            mobile_view: false,
            cust_id: '',
            full_payment: false,
            wallet_checkbox: false,
            paymentPopUp: false,
            payment_footer: false,
            stripe_checked: false,
            card_errors: "",
            paymentdetails: [],
            Credit_card: true,
            total: 0,
            deposit: 0,
            wallet_amount: 0,
            total_wallet_amount: 0,
            cust_name: '',
            booking_details: [],
            stripe_intents: '',
            card_number: "",
            expire_Date: "",
            cvv: "",
            card: '',
            cardExpiryElement: '',
            cardCvcElement: '',
            pub_key: '',
            stripe: '',
            elements: '',
            pay_fullpayment: JSON.parse(this.$session.get('cust_banned_data')).pay_fullpayment,
            card_style: {
                base: {
                    fontFamily: 'Quicksand , sans-serif',
                    fontWeight: 'normal',
                    letterSpacing: '0.1rem',
                    fontSize: '16px',
                    '::placeholder': {
                        color: '#C6C6C6',
                    },
                }
            },
        }
    },
    async mounted() {
        if (this.$session.get('cust_details') && !this.$session.get('service_obj')) {
            this.$router.push('/mybookings');
        }
        await this.getUnpaidBookingDetails();
        await this.$store.dispatch('getStoreDetails', [this.$store.state.api, this.$store.state.store_url_name]);
        this.appId = this.$store.state.cust_store_data.store_api_square_app_id;
        this.locationId = this.$store.state.cust_store_data.store_api_square_location_id;
        this.pub_key = this.$store.state.cust_store_data.store_api_publish_key;

        if (this.pub_key && (this.locationId && this.appId)) {
            this.payment_card = true;
            this.payment_footer = true;
            var textEle = document.getElementById('waitText');
            textEle.textContent = "Please wait......"
            await this.card_load();



        } else if (this.locationId && this.appId) {
            this.payment_card = true;
            this.show_stripe = false;
            this.value = 'square';
            this.stripe_checked = false;
            this.square_checked = true;

            var Ele = document.getElementById('waitText');
            Ele.textContent = "Please wait......"
            await this.card_load();
            this.payment_footer = true;


        } else if (this.pub_key) {
            this.payment_card = true;
            this.show_square = false;
            this.value = 'stripe';
            this.stripe_checked = true;
            this.square_checked = false;
            this.stripe = window.Stripe(this.pub_key);
            this.elements = this.stripe.elements();
            this.responsive_view();
            window.addEventListener('resize', this.responsive_view);
            await this.credit_card_details();
        }

        this.$store.state.total_services_in_cart = this.booking_details.length;

        if (this.pay_fullpayment == 1) {
            this.full_payment = true;
        }

    },

    /*   beforeDestroy() { 
          
          let _this = this;
          _this.card.destroy('#stpcardNumber');
          _this.cardExpiryElement.destroy('#stpcardExpiry');
          _this.cardCvcElement.destroy('#stpcardCvv')
      }, */
    computed: {
        cust_payable_amount() {
            if (this.full_payment) {
                return this.total;
            } else
                return this.deposit;
        },
    },
    methods: {
        //square//


        async initializeCard(payments) {
            const card = await payments.card({
                style: this.cardClassSelectors,
            });

            var textEle = document.getElementById('waitText');
            textEle.textContent = ""
            await card.attach('#card-container');
            return card;
        },

        async squareTransaction(token) {
            if (this.wallet_checkbox && this.square_checked && this.full_payment) {
                this.square_pay_amount = this.total - this.wallet_amount;
            } else if (this.wallet_checkbox && this.square_checked) {
                this.square_pay_amount = this.deposit - this.wallet_amount;
            } else if (this.square_checked && this.full_payment) {
                this.square_pay_amount = this.total;
            } else if (this.square_checked) {
                this.square_pay_amount = this.deposit;
            }

            try {
                this.square_payment_object = {
                    "bookings": this.booking_details,
                    "full_amount_flag": this.full_payment ? 1 : 0,
                    "square_pay_amount": this.square_pay_amount,
                    "wallet_pay_flag": this.wallet_checkbox ? 1 : 0,
                    "square_token": token
                }
                await this.$store.dispatch('squarePayment', [this.$store.state.api, this.square_payment_object]);
                this.square_payment_response = this.$store.state.square_payments.square_response;
                this.square_response_object = {
                        "id": this.square_payment_response.id,
                        "orderId": this.square_payment_response.orderId,
                        "receiptUrl": this.square_payment_response.receiptUrl,
                        "amount": parseFloat(this.square_payment_response.amount),
                        "status": this.square_payment_response.status
                    },
                    this.makeTransaction();

            } catch (e) {
                console.log(e.message);
                var error = document.getElementById('errors-container')
                error.textContent = 'Your transaction could not be processed. Please enter a valid card with sufficient balance';
                this.$store.state.loader_popup = false;
                this.payment_footer = true;
            }

        },

        async tokenize(paymentMethod) {

            const tokenResult = await paymentMethod.tokenize();

            if (tokenResult.status === 'OK') {
                return tokenResult.token;
            } else {
                let errorMessage = `Tokenization failed-status: ${tokenResult.status}`;
                if (tokenResult.errors) {
                    this.$store.state.loader_popup = false;
                    this.payment_footer = true;
                }
                throw new Error(errorMessage);
            }
        },

        //............mounted part..........

        async card_load() {
            if (!window.Square) {
                throw new Error('Square.js failed to load properly');
            }
            const payments = window.Square.payments(this.appId, this.locationId);
            try {
                this.sqCard = await this.initializeCard(payments);
            } catch (e) {
                console.error('Initializing Card failed', e);
                return;
            }
        },

        //............mounted part............

        async handlePaymentMethodSubmission(paymentMethod) {
            try {
                const token = await this.tokenize(paymentMethod);
                await this.squareTransaction(token);
            } catch (e) {
                this.$store.state.loader_popup = false;
                this.payment_footer = true;
                console.error(e.message);
            }
        },

        async sqProceedToPay() {
            await this.handlePaymentMethodSubmission(this.sqCard);
        },

        //square//


        async getUnpaidBookingDetails() {
            this.$store.state.loader_popup = true;
            if (this.$session.get('unpaid_booking_details') && JSON.parse(this.$session.get('unpaid_booking_details')).length > 0) {
                this.booking_details = JSON.parse(this.$session.get('unpaid_booking_details'));

                await this.$store.dispatch('getPaymentDetails', [this.$store.state.api, this.booking_details]);
                this.$ga.page(this.$router);
                if (Object.keys(this.$store.state.paymentdetails_data).length > 0) {
                    this.paymentdetails = this.$store.state.paymentdetails_data;
                    this.total = this.$store.state.paymentdetails_data.pay_fullamount;
                    this.deposit = this.$store.state.paymentdetails_data.pay_deposit;
                    this.cust_id = this.paymentdetails.bookings.service_bookings[0].cust_id;
                    for (let i = 0; i < this.paymentdetails.cust_wallet.length; i++) {
                        this.wallet_amount = this.paymentdetails.cust_wallet[i].amount;
                    }
                } else {
                    this.paymentdetails = [];
                }
            }
            this.$store.state.loader_popup = false;
        },

        close_paymentfailed_popup() {
            this.paymentPopUp = false;
        },

        async responsive_view() {
            await this.$store.commit('responsive_view', window.innerWidth)
        },


        //tab change for stripe & square
        async selectCard(value) {

            if (value == 'square') {
                this.value = value;
                this.payment_footer = true;
                this.stripe_checked = false;
                this.square_checked = true;
            } else {
                this.value = value;
                this.payment_footer = false;
                this.stripe_checked = true;
                this.square_checked = false;
                if (this.str_card_load) {
                    this.stripe = window.Stripe(this.pub_key);
                    this.elements = this.stripe.elements();
                    this.responsive_view();
                    window.addEventListener('resize', this.responsive_view);
                    await this.credit_card_details();
                    this.str_card_load = false;
                }
            }
        },
        //tab change for stripe & square


        change_payable_amount(type) {
            let _this = this;
            var amount = this.deposit;

            if (this.$store.state.pay_fullpayment == 1) {
                this.full_payment = true;
            }
            if (type == 'toggle') {
                this.full_payment = !this.full_payment;
            }
            if (type == 'check_box') {
                this.wallet_checkbox = !this.wallet_checkbox;
            }

            if (this.full_payment) {
                amount = this.total;
            } else {
                amount = this.deposit;
            }

            if ((amount <= this.wallet_amount) && this.wallet_checkbox) {
                this.total_wallet_amount = amount;
                this.Credit_card = false;
                this.square_card = false;
                this.payment_card = false;
                this.stripe_checked = false;
                this.square_checked = false;
                this.payment_footer = true;

            } else {
                if ((amount > this.wallet_amount) && this.wallet_checkbox) {
                    this.total_wallet_amount = this.wallet_amount;
                }
                this.Credit_card = true;
                this.square_card = true;
                this.payment_card = true;
                if (this.value == 'stripe') {
                    this.stripe_checked = true;
                    this.square_checked = false;
                } else {
                    this.stripe_checked = false;
                    this.square_checked = true;
                }
                _this.credit_card_error_handler();

            }
        },


        credit_card_details() {
            let _this = this;
            _this.card = this.elements.create('cardNumber', { style: this.card_style, placeholder: 'xxxx xxxx xxxx xxxx' });
            _this.cardExpiryElement = this.elements.create('cardExpiry', { style: this.card_style });
            _this.cardCvcElement = this.elements.create('cardCvc', { style: this.card_style });
            setTimeout(function() {
                _this.card.mount('#stpcardNumber');
                _this.cardExpiryElement.mount('#stpcardExpiry');
                _this.cardCvcElement.mount('#stpcardCvv');
                _this.card.addEventListener('focus', function() {
                    window.scrollTo(0, window.pageYOffset + 60);
                });
                _this.cardExpiryElement.addEventListener('focus', function() {
                    window.scrollTo(0, window.pageYOffset + 60);
                });
                _this.card.addEventListener('change', function(event) {

                    var displayError = document.getElementById('card-errors');
                    if (event.error) {
                        displayError.textContent = event.error.message;
                        _this.payment_footer = false;
                    } else {
                        displayError.textContent = '';
                    }
                    _this.card_number = event.complete ? true : false;
                    _this.credit_card_error_handler();

                });
                _this.cardExpiryElement.addEventListener('change', function(event) {
                    _this.expire_Date = event.complete ? true : false;
                    _this.credit_card_error_handler();
                });
                _this.cardCvcElement.addEventListener('change', function(event) {
                    _this.cvv = event.complete ? true : false
                    _this.credit_card_error_handler();
                });
            }, 100);
        },

        credit_card_error_handler() {
            let _this = this;
            if (this.value == 'stripe') {
                if (_this.card_number && _this.expire_Date && _this.cvv) {
                    _this.payment_footer = true;
                } else {
                    _this.payment_footer = false;
                }
            } else {
                _this.payment_footer = true;
            }

        },


        proceedToPay() {
            this.$store.state.loader_popup = true;
            let _this = this,
                stripe = true;
            this.payment_footer = false;
            var cust_details = JSON.parse(this.$session.get('cust_details'));
            if (this.wallet_checkbox && this.stripe_checked && this.full_payment) {
                this.stripe_details = this.paymentdetails.stripe_intents.fullamount_wallet;
            } else if (this.wallet_checkbox && this.stripe_checked) {
                this.stripe_details = this.paymentdetails.stripe_intents.deposit_wallet;
            } else if (this.stripe_checked && this.full_payment) {
                this.stripe_details = this.paymentdetails.stripe_intents.total_fullamount;
            } else if (this.stripe_checked) {
                this.stripe_details = this.paymentdetails.stripe_intents.total_deposit;
            } else {
                stripe = false;
                this.stripe_details = {};
            }
            if (stripe && this.value == 'stripe') {
                this.stripe.confirmCardPayment(this.stripe_details.client_secret, {
                    payment_method: {
                        card: this.card,
                        billing_details: {
                            email: cust_details.cust_email,
                            name: 'booking type: ' + this.booking_details[0].type + ' id: ' + this.booking_details[0].booking_id
                        }
                    }
                }).then(function(result) {
                    if (result.error) {
                        // Inform the user if there was an error.
                        var errorElement = document.getElementById('card-errors');
                        errorElement.textContent = "Your transaction could not be processed. Please enter a valid card with sufficient balance";
                        _this.$store.state.loader_popup = false;
                    } else {
                        _this.makeTransaction();


                    }
                })

            } else if (this.value == 'square' && this.square_checked) {
                this.sqProceedToPay()
            } else {
                this.square_response_object = {}
                _this.makeTransaction();

            }

        },

        makeTransaction() {
            var cust_details = JSON.parse(this.$session.get('cust_details'));
            if (this.wallet_checkbox && this.stripe_checked && this.full_payment) {
                this.stripe_details = this.paymentdetails.stripe_intents.fullamount_wallet;
            } else if (this.wallet_checkbox && this.stripe_checked) {
                this.stripe_details = this.paymentdetails.stripe_intents.deposit_wallet;
            } else if (this.stripe_checked && this.full_payment) {
                this.stripe_details = this.paymentdetails.stripe_intents.total_fullamount;
            } else if (this.stripe_checked) {
                this.stripe_details = this.paymentdetails.stripe_intents.total_deposit;
            } else {
                this.stripe_details = {};
            }
            try {
                axios.post(this.$store.state.api + `v2/transactions/complete_payment_transactions_cust_bookings_v2`, {
                    "bookings": this.booking_details,
                    "store_id": parseInt(JSON.parse(this.$session.get('store_details')).store_id),
                    "cust_id": this.cust_id,
                    "cust_email": cust_details.cust_email,
                    "pay_deposit": this.deposit,
                    "pay_fullamount": this.total,
                    "wallet_pay_flag": this.wallet_checkbox ? 1 : 0,
                    "wallet_pay_amount": this.total_wallet_amount,
                    "full_amount_flag": this.full_payment ? 1 : 0,
                    "stripe_pay_flag": this.stripe_checked ? 1 : 0,
                    "stripe_payment_intent": this.stripe_details,
                    "square_pay_flag": this.square_checked ? 1 : 0,
                    "square_response": this.square_response_object

                }).then((response) => {
                    console.log(response.data.status);
                    this.$router.push('/bookingsuccess')
                }, error => {
                    console.log(error)
                    this.$store.state.loader_popup = false;
                    this.paymentPopUp = true;
                })
            } catch (e) {
                this.$store.state.loader_popup = false;
                this.paymentPopUp = true;
            }

        },

    }
}